




































import {Vue, Component, Prop} from "vue-property-decorator";
import {HashMap} from "./../services/base.service";
import ServiceService, { IService } from "../services/service.service";
import Icons from "../services/icons.service";
import { IconLookup } from "@fortawesome/fontawesome-svg-core";

@Component({
    components: {
    }
})
export default class ServiceForm extends Vue {

    @Prop()
    public service!: IService;

    private request!: IService;

    private api!: ServiceService;

    private errors: HashMap<string> = {};

    private loading: boolean = false;

    private error: string | null = null;
    private success: string | null = null;

    private editing: boolean = false;

    private icons: IconLookup[] = [];

    private async created() {
        this.api = new ServiceService();
        this.icons = Icons.GetStandardIcons();
        if (this.service) {
            this.request = this.service;
            this.editing = true;
        } else {
            this.request = {
                name: '',
                icon: '',
                slug: '',
                description: '',
                longDescription: ''
            }
        }
    }

    private async submit() {
        this.loading = true;

        const res = this.editing ? await this.api.put(this.service.id as string, this.request) : await this.api.post(this.request);

        this.success = null;
        this.error = null;

        if (res.success) {
            this.success = "Service saved successfully";
            this.$router.push({name: 'Service', params: {id: res.result.id as string}});
        } else {
            this.errors = res.error;
            this.error = "Failed to save service";
            setTimeout(() => {
                this.error = null;
            }, 2000);
        }

        this.loading = false;
    }
}

